import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import { GlobalModal } from "components/globalModal/GlobalModal";
import { TableCustom } from "components/table/TableCustom";
import {
  selectCurrentJob,
  selectIsLoading,
  selectIsLoadingJobDWOs,
  selectJobDWOForemen,
} from "features/jobs/jobsSlice";
import { noop } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getTimesheetsModalRows,
  jobTimesheetsModalColumns,
} from "utils/jobDetailsUtils";
import { MainTableRow } from "utils/tableUtils";

interface TimesheetsModalProps {
  isOpen: boolean;
  title?: string;
  onClickClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    description: {
      color: theme.palette.grey[500],
    },
  }),
);

export function TimesheetsModal({
  isOpen,
  title = "Select Timesheet",
  onClickClose,
}: TimesheetsModalProps) {
  const [jobDWOs, setJobDWOs] = useState<MainTableRow[]>([]);
  const isLoadingDWOJobs = useSelector(selectIsLoadingJobDWOs);
  const isLoadingJobdata = useSelector(selectIsLoading);
  const jobData = useSelector(selectCurrentJob);
  const jobDWOForemen = useSelector(selectJobDWOForemen);
  const classes = useStyles();

  useEffect(() => {
    if (jobData && jobDWOForemen.length) {
      const formattedJobDWOs = getTimesheetsModalRows(jobDWOForemen, jobData);
      setJobDWOs(formattedJobDWOs);
    }
  }, [jobData, jobDWOForemen]);

  const isLoading = isLoadingDWOJobs || isLoadingJobdata;

  const description = (
    <Box margin="0 24px 24px 24px">
      <Typography className={classes.description} variant="body2">
        Select a Timesheet to View.
      </Typography>
    </Box>
  );

  return (
    <GlobalModal
      Filters={description}
      open={isOpen}
      showActionButtons={false}
      title={title}
      onClickClose={onClickClose}
    >
      <TableCustom
        columns={jobTimesheetsModalColumns}
        isLoading={isLoading}
        rows={jobDWOs}
        onClickSort={noop}
      />
    </GlobalModal>
  );
}
